import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Button, Stack, Typography } from '@mui/material'
import { AlertContext } from 'Layout'
import { CheckBoxWithLabel } from 'components/CheckBoxWithLabel/CheckBoxWithLabel'
import CustomTextField from 'components/CustomTextField/CustomTextField'
import { Loading } from 'components/Loading/Loading'
import TicketData, { TicketDataRow } from 'components/TicketData/TicketData'
import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { RegisBody, checkCode, regis } from 'service/PreregisService'
import FormBuilder, { createYupSchema } from 'components/FormBuilder/FormBuilder'
import { create } from 'domain'
import { PreRegisForm, formFieldsConfig } from './RegistrationFormDecorator'

const RegistrationForm: React.FC<{}> = ({}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isAcceptPolicy, setIsAcceptPolicy] = useState(false)
  const [ticketData, setTicketData] = useState<TicketDataRow[]>([])
  const { qrCode } = useParams()
  const navigate = useNavigate()
  const { setAlert } = useContext(AlertContext)

  const formControl = useForm<PreRegisForm>({
    defaultValues: {},
    resolver: yupResolver(createYupSchema(formFieldsConfig)),
  })

  const onSubmit = async () => {
    // alert(JSON.stringify(formControl.getValues(), null, 2));
    // console.log(formControl.formState.errors);

    if (!!!qrCode) return

    setIsLoading(true)
    formControl.handleSubmit(async (data) => {
      const body: any = {
        FIRST_NAME: formControl.getValues('firstName')?.trim(),
        LAST_NAME: formControl.getValues('lastName')?.trim(),
        EMAIL: formControl.getValues('email')?.trim(),
        PHONE_NUMBER: formControl.getValues('phoneNumber')?.replace(/\s/g, ''),
      }

      const response = await regis(qrCode, body)

      if (response.data.statusCode !== 0) {
        setAlert({
          message: 'Some things went wrong. Please try again later.',
          alertType: 'error',
        })
        return
      }

      navigate(`/thankyou/${qrCode}`)
    })()
    setIsLoading(false)
  }

  useEffect(() => {
    const check = async (code: string) => {
      const response = await checkCode(code)
      const rawData = response?.data?.data

      setTicketData([
        {
          tittle: 'Ticket Type:',
          value: rawData?.ticketTypeDetail?.name,
        },
        {
          tittle: 'Entrant Code:',
          value: rawData?.dataTicket?.code,
        },
      ])
    }

    if (!!!qrCode) {
      navigate('/')
      return
    }

    check(qrCode)
  }, [])

  return (
    <>
      <Stack direction={'column'} spacing={2}>
        {/* <TicketData showImage tittle="Your Ticket Details" rows={ticketData} /> */}
        <Box>
          <Typography variant="body2" sx={{ fontSize: '14px', whiteSpace: 'pre-wrap' }}>
            {
              'Please fill in your information below.\nMake sure the name matches what’s printed in your ID and that your email address is active.'
            }
          </Typography>
        </Box>
        <Box>
          <FormBuilder formFieldsConfig={formFieldsConfig} />
          <Stack spacing={1.5}>
            <CustomTextField<PreRegisForm>
              formControl={formControl}
              fieldName="firstName"
              label="First Name"
              required
            />
            <CustomTextField<PreRegisForm>
              formControl={formControl}
              fieldName="lastName"
              label="Last Name"
              required
            />
            <CustomTextField<PreRegisForm>
              formControl={formControl}
              fieldName="email"
              label="E-mail"
              required
            />
            <CustomTextField<PreRegisForm>
              formControl={formControl}
              fieldName="phoneNumber"
              label="Phone Number"
              required
            />
          </Stack>
        </Box>
        <Stack spacing={2}>
          <CheckBoxWithLabel
            label={
              <div>
                {`I accept ${process.env.REACT_APP_EVENT_NAME} `}
                <a
                  className="text-primary underline"
                  href={process.env.REACT_APP_PRIVACY_AND_POLICY}
                  target="_blank"
                >
                  {'Privacy Policy'}
                </a>
                {' and '}
                <a
                  className="text-primary underline"
                  href={process.env.REACT_APP_TERMS_AND_CONDITION}
                  target="_blank"
                >
                  {'Terms and Conditions'}
                </a>
              </div>
            }
            isCheck={isAcceptPolicy}
            setIsCheck={setIsAcceptPolicy}
          />
          <div className="flex justify-center">
            <Button
              variant="contained"
              onClick={onSubmit}
              fullWidth
              disabled={!isAcceptPolicy}
              sx={
                {
                  // "&.Mui-disabled": {
                  //   backgroundColor: "rgba(255, 255, 255, 0.2)",
                  // },
                }
              }
            >
              {'submit'}
            </Button>
          </div>
        </Stack>
      </Stack>
      <Loading isLoading={isLoading} />
    </>
  )
}

export default RegistrationForm
